<template>
    <div class="availabilities__section changed-availabilities-section">
        <div class="box box-shadow">
            <div class="availabilities__wrapper--inner" v-if="readOnly">
                <div class="columns">
                    <div class="column">
                        <h3>
                            <i
                                class="fa fa-exclamation-triangle is-danger align_base"
                                aria-hidden="true"
                                v-if="lastApicallWarningLevel > 0"
                            />
                            {{ $t("availabilities.intro.headline4") }}
                        </h3>
                    </div>
                </div>

                <div class="columns last-api-call">
                    <div class="column">
                        <div class="notification is-yellow" v-if="!lastApiCall">
                            {{ $t("availabilities.intro.copy4") }}
                        </div>

                        <div v-else class="columns">
                            <div class="column is-tablet-6 is-12">
                                <table class="table is-bordered">
                                    <tbody>
                                        <tr>
                                            <th class="is-narrow head">Aktion</th>
                                            <th class="is-narrow head">
                                                {{ $t("availabilities.infoTable.dateAndTime") }}
                                            </th>
                                            <th class="is-narrow head">
                                                {{ $t("availabilities.infoTable.timePassedSince") }}
                                            </th>
                                            <th class="is-narrow head">
                                                {{ $t("availabilities.infoTable.state") }}
                                            </th>
                                        </tr>

                                        <tr>
                                            <td>{{ $t('availabilities.infoTable.actionAvailabilities') }}</td>
                                            <td>
                                                <span class="tag" v-if="lastApiCall.date">
                                                    {{ lastApiCall.date | localizedDate($t("generic.calendar.dateformatMomentjsFull"))}}
                                                    {{ lastApiCall.date | localizedDate($t("generic.calendar.timeformatMomentjsFull"))}}
                                                </span>
                                                <span v-else>-</span>
                                            </td>
                                            <td v-html="lastApicallErrorTimeSince"></td>
                                            <td v-html="lastApicallError"></td>
                                        </tr>

                                        <tr>
                                            <td>{{ $t('availabilities.infoTable.actionReadBookings') }}</td>
                                            <td>
                                                <span class="tag">
                                                    {{ lastApiCall.readrq_date | localizedDate($t("generic.calendar.dateformatMomentjsFull"))}}
                                                    {{ lastApiCall.readrq_date | localizedDate($t("generic.calendar.timeformatMomentjsFull"))}}
                                                </span>
                                            </td>
                                            <td v-html="lastReadRqApicallErrorTimeSince"></td>
                                            <td v-html="lastReadRqApicallError"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <h3>
                    <i class="fa fa-info-circle fa-lg align_base" aria-hidden="true" />
                    {{ $t("availabilities.intro.headline5") }}
                </h3>
                <span class="columns"
                    ><span class="column">{{ $t("availabilities.intro.info5") }}</span></span
                >
                <span class="columns"><span class="column">&nbsp;</span></span>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment/moment';
import filters from '../../../filters';
import { AppModel } from '../../../models';

export default {
    name: 'pms-info-box',
    filters: filters,
    data() {
        return {
            readOnly: false,
            lastApiCall: null,
            lastApicallErrorTimeSince: null,
            lastApicallErrorTimeSinceInterval: null,
            lastReadRqApicallErrorTimeSince: null,
            lastReadRqApicallErrorTimeSinceInterval: null,
            lastReadRqTimeSince: null
        };
    },
    created() {
        this.lastApiCall = AppModel.activeCampground.last_api_call;
        this.readOnly = AppModel.activeCampground.settings.pms_api_active;
        this.setLastApicallErrorTimeSince(this.lastApiCall && this.readOnly);
        this.setLastReadRqApicallErrorTimeSince(this.lastApiCall && this.readOnly);
    },
    computed: {
        lastApicallError() {
            if(!this.lastApiCall || this.lastApiCall.date === null) {
                return '';
            }

            if(this.lastApiCall.error) {
                return (
                    '<span class="tag is-danger">' +
                    this.$t('availabilities.intro.erroneous') +
                    '</span>'
                );
            } else {
                return (
                    '<span class="tag is-success">' +
                    this.$t('availabilities.intro.successful') +
                    '</span>'
                );
            }
        },
        lastReadRqApicallError() {
            if(!this.lastApiCall) {
                return '';
            }

            if(this.lastApiCall.readrq_error) {
                return (
                    '<span class="tag is-danger">' +
                    this.$t('availabilities.intro.erroneous') +
                    '</span>'
                );
            } else {
                return (
                    '<span class="tag is-success">' +
                    this.$t('availabilities.intro.successful') +
                    '</span>'
                );
            }
        },
        lastApicallWarningLevel() {
            if(!this.lastApiCall || !this.lastApiCall.date) {
                return 0;
            }
            const diff = moment().diff(this.lastApiCall.date) / 3600000;
            let level = 0;
            if(diff > 5) {
                level = 1;
            }
            if(diff >= 48) {
                level = 2;
            }
            return level;
        }
    },
    methods: {
        setLastApicallErrorTimeSince(createTimeout = false) {
            if(!this.lastApiCall || !this.lastApiCall.date) {
                return;
            }

            const level = this.lastApicallWarningLevel;
            const status = ['is-success', 'is-warning', 'is-danger'];

            let timeSince = moment(this.lastApiCall.date).fromNow(true);
            this.lastApicallErrorTimeSince = `<span class="tag ${status[level]}">${timeSince}</span>`;
            if(createTimeout) {
                this.lastApicallErrorTimeSinceInterval = setInterval(() => {
                    this.setLastApicallErrorTimeSince();
                }, 5);
            }
        },
        setLastReadRqApicallErrorTimeSince(createTimeout = false) {
            if(!this.lastApiCall || !this.lastApiCall.readrq_date) {
                return;
            }

            const level = this.lastApicallWarningLevel;
            const status = ['is-success', 'is-warning', 'is-danger'];

            let timeSince = moment(this.lastApiCall.readrq_date).fromNow(true);
            this.lastReadRqApicallErrorTimeSince = `<span class="tag ${status[level]}">${timeSince}</span>`;
            if(createTimeout) {
                this.lastReadRqApicallErrorTimeSinceInterval = setInterval(() => {
                    this.setLastReadRqApicallErrorTimeSince();
                }, 5);
            }
        }
    }
};
</script>

<style lang="scss" scoped src="./pms-info-box.scss" />

<style lang="css" scoped>
.align_base {
    vertical-align: baseline;
}
</style>



// WEBPACK FOOTER //
// src/views/components/pms-info-box/pms-info-box.vue